module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/browser-support-table/browser-support-table.component.scss
// module id = ./src/app/shared-components/browser-support-table/browser-support-table.component.scss
// module chunks = main